import { TabQueryState } from '@/components/layout/query-state';
import { TAB_BOTTOM_SPACING, TabScreenWrapper } from '@/components/layout/tab-screen-wrapper';
import { PageTitle } from '@/components/seo/page-title';
import { ProfileScreen } from '@/features/profile/profile-screen';
import { useOtherUserProfile } from '@/features/profile/hooks/use-other-user-profile';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function ProfileRoute() {
  const { username } = useLocalSearchParams<{ username: string }>();
  const {
    profileData,
    isLoading,
    error,
    isCurrentUser,
    onRefresh,
    refreshing,
    refetch,
    title,
  } = useOtherUserProfile(username);

  return (
    <TabQueryState
      isLoading={isLoading}
      error={error}
      onRetry={() => refetch()}
      loadingMessage="Loading profile..."
    >
      <PageTitle title={title} />
      {profileData?.user ? (
        <TabScreenWrapper>
          <ProfileScreen
            user={profileData.user}
            isCurrentUser={isCurrentUser}
            title={title}
            onRefresh={onRefresh}
            refreshing={refreshing}
            bottomInset={TAB_BOTTOM_SPACING}
          />
        </TabScreenWrapper>
      ) : null}
    </TabQueryState>
  );
}
